import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var ContextMenuClipboardItems = /** @class */ (function (_super) {
    __extends(ContextMenuClipboardItems, _super);
    function ContextMenuClipboardItems() {
        var _this = _super.call(this) || this;
        _this._cut = true;
        _this._copy = true;
        _this._paste = true;
        _this._clear = true;
        _this._selectAll = true;
        return _this;
    }
    Object.defineProperty(ContextMenuClipboardItems.prototype, "cut", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'get cut', '');
            return this._cut;
        },
        set: function (val) {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'set cut', '');
            this._cut = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuClipboardItems.prototype, "copy", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'get copy', '');
            return this._copy;
        },
        set: function (val) {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'set copy', '');
            this._copy = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuClipboardItems.prototype, "paste", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'get paste', '');
            return this._paste;
        },
        set: function (val) {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'set paste', '');
            this._paste = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuClipboardItems.prototype, "clear", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'get clear', '');
            return this._clear;
        },
        set: function (val) {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'set clear', '');
            this._clear = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuClipboardItems.prototype, "selectAll", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'get selectAll', '');
            return this._selectAll;
        },
        set: function (val) {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenuClipboardItems', 'set selectAll', '');
            this._selectAll = !!val;
        },
        enumerable: false,
        configurable: true
    });
    ContextMenuClipboardItems.prototype.clone = function () {
        var items = new ContextMenuClipboardItems();
        items._cut = this._cut;
        items._copy = this._copy;
        items._paste = this._paste;
        items._clear = this._clear;
        items._selectAll = this._selectAll;
        return items;
    };
    ContextMenuClipboardItems.classInitializer = null;
    ContextMenuClipboardItems.classSymbols = null; // [];
    ContextMenuClipboardItems.instanceSymbols = null;
    return ContextMenuClipboardItems;
}(ASObject));
export { ContextMenuClipboardItems };
